module.exports = __webpack_public_path__ + "img/Italian.60bff951.svg";